import { SectionTitle } from '../../../../../../components/text';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { Button, CheckInput } from '@octano/global-ui';
import { TableDegreeDocuments } from './parts/TableDegreeDocuments';
import { useState } from 'react';
import { AddDocumentModal } from './parts/AddDocumentModal';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { DegreeDocumentFormValues } from './types';

export function DegreeDocuments() {
  const { t } = useTranslation();
  const prefix = 'studyPlans.curriculum.degreeDocuments';
  const [openAddDocumentModal, setOpenAddDocumentModal] =
    useState<boolean>(false);

  const { watch, setValue, control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'degreeDocuments',
    keyName: 'fieldId',
  });

  const [hasDegreeDocumentsChecked] = watch(['hasDegreeDocumentsChecked']);

  return (
    <Row>
      <Col xs={12}>
        <Row>
          <Col xs={12}>
            <SectionTitle text={t(`${prefix}.title`)} />
          </Col>
        </Row>
        <Row className="pb-3">
          <Col xs={12}>
            <span className="fs-18">{t(`${prefix}.subtitle`)}</span>
          </Col>
        </Row>
      </Col>
      <Col xs={12}>
        <Row className="d-flex justify-content-end">
          <Col xs={12} md={4}>
            <Button
              className="btn-block"
              size="md"
              text={t(`${prefix}.addDocument`)}
              icon="plus"
              onClick={() => setOpenAddDocumentModal(true)}
              disabled={hasDegreeDocumentsChecked}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-end mt-3">
          {fields.length === 0 && (
            <Col xs={12} md={6}>
              <div className="d-flex justify-content-end">
                <CheckInput
                  name="addDocument"
                  value={hasDegreeDocumentsChecked}
                  label={t(`${prefix}.checkbox`)}
                  onChange={() => {
                    setValue(
                      'hasDegreeDocumentsChecked',
                      !hasDegreeDocumentsChecked,
                    );
                  }}
                />
              </div>
            </Col>
          )}
        </Row>
      </Col>

      <Col xs={12}>
        <TableDegreeDocuments
          degreeDocuments={
            fields as (DegreeDocumentFormValues & { fieldId: string })[]
          }
          remove={remove}
        />
      </Col>
      {openAddDocumentModal && (
        <AddDocumentModal
          toggleDialog={() => setOpenAddDocumentModal(false)}
          append={append}
        />
      )}
    </Row>
  );
}
